export default "__VITE_PUBLIC_ASSET__bbf8cb64__"